module.exports = __webpack_public_path__ + "static/media/anetta.7ef4db4a.png";